import {
	NavigateFn,
	NavigateOptions,
	useNavigate as useTanstackNavigate,
} from '@tanstack/react-router'
import { MouseEvent } from 'react'
import router, { getRouteMatch } from '../router'

export interface UniversalNavigate {
	(url: string, e?: MouseEvent<Element, globalThis.MouseEvent>): Promise<void>
	(
		options: NavigateOptions<typeof router>,
		e?: MouseEvent<Element, globalThis.MouseEvent>
	): Promise<void>
}

export default function useUniversalNavigate() {
	const navigate = useTanstackNavigate()

	return function uniNavigate(linkOrOptions, e): ReturnType<NavigateFn> {
		const isMetaKeyOrCtrlKeyPressed = !!(e?.metaKey || e?.ctrlKey)

		if (typeof linkOrOptions === 'string') {
			const link = linkOrOptions
			const match = getRouteMatch(link)

			if (!match) {
				window.open(link, '_blank')
				return Promise.resolve()
			}

			linkOrOptions = match
			if (!linkOrOptions.to) {
				linkOrOptions.to = match.fullPath
			}
		}

		if (isMetaKeyOrCtrlKeyPressed) {
			const location = router.buildLocation(linkOrOptions)
			window.open(location.href, '_blank')
			return Promise.resolve()
		}

		return navigate(linkOrOptions)
	} as UniversalNavigate
}
